export class User {
  constructor(
    public _id: string,
    public name: string,
    public email: string,
    public exp: Date,
    public status: string,
    public regCode: string,
    public mobileNo: string,
    public phoneNo: string,
    public profilePicture: object,
    public description: string,
    public position: string,
    public residence: string,
    public workplace: string,
    public firstLogin: string,
    public dashboardSettings: object,
    public grade: string,
  ) {}
}
